// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './i18n'
// 图片懒加载
import lazyLoad from './directives/lazyLoad'
// 滚动到「申请试用」区块
import scrollToApply from './utils/scrollToApply'
// 全局轻量提示（自实现，替代 element-ui 的 $message）
import toast from './utils/toast'
// 全局设计变量（颜色 / 字号 / 间距 / 圆角的唯一来源）
import './styles/tokens.css'
// 全局基础样式（reset / .container / section 间距 / 通用标题按钮 / 滚动动画）
import './styles/base.css'

Vue.use(lazyLoad)
Vue.use(scrollToApply)
Vue.use(toast)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  // 用 render 而非 template：配合 runtime-only 构建（见 webpack.base.conf.js 的 vue$ 别名）
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js